module.exports = __webpack_public_path__ + "static/media/caproc-iot_dashboard.7b1cd2be.png";